import httpBuildQuery from '../../../httpBuildQuery'

export const FETCH_ACTION_INTEGRATIONS = 'V2/ActionIntegrations/Fetch'
export const FETCH_ACTION_INTEGRATIONS_FOR_TRACE_BOOSTS = 'V2/ActionIntegrations/Fetch/Tracepoints'

export const fetchActionIntegrations = () => ({
    type: FETCH_ACTION_INTEGRATIONS,
    payload: ({ fetchForApplication }) => fetchForApplication('/action-integrations'),
})

export const fetchActionIntegrationsForTracepoints = (environment: string, service: string) => ({
    type: FETCH_ACTION_INTEGRATIONS_FOR_TRACE_BOOSTS,
    payload: ({ fetchForApplication }) =>
        fetchForApplication('/action-integrations-for-tracepoints?' + httpBuildQuery({ s: service, env: environment })).then(data => ({
            data,
            environment,
            service,
        })),
})
